export default "__VITE_ASSET__CE0jwwUO__"